var $f2145ca14f5f957a$exports = {};
$f2145ca14f5f957a$exports = {
    "info": `Bilgiler`,
    "negative": `Hata`,
    "notice": `Uyar\u{131}`,
    "positive": `Ba\u{15F}ar\u{131}l\u{131}`
};


export {$f2145ca14f5f957a$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
